const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },

  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    /* Body/Body 2 */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 24px */,
  },
  headerContainer: {
    flex: '1 0 0',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  courseHeader: {
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  courseDiv: {
    width: '100%',
  },
})

export default styles
